import type { ReactNode } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ConfirmTickCard } from './ConfirmTickCard';

interface VcaClinicMessagesStepProps {
    warning: ReactNode;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

function VcaClinicMessagesStep({ warning, checked, onChange }: VcaClinicMessagesStepProps) {
    return (
        <div className="w-full flex flex-col gap-4">
            <h3 className="text-sm font-semibold text-gray-800">Clinic messages</h3>

            <div className="flex items-start gap-3 p-4 rounded-xl border border-yellow-200 bg-yellow-50">
                <ExclamationTriangleIcon className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                <div className="text-sm text-gray-800">{warning}</div>
            </div>

            <ConfirmTickCard
                checked={checked}
                onChange={onChange}
                label="I've checked for recent clinic messages."
            />
        </div>
    );
}

export { VcaClinicMessagesStep };
